import React from 'react';
import { PolicyFromText } from '../../components/ui/PolicyFromText';
import { termsOfService } from '../../data/policies/terms';
export function Terms() {
  return <PolicyFromText doc={termsOfService} data-id="element-1082" data-mp="2a64l7npctgi" />;
}